export default __webpack_public_path__ + "static/TeamBanking-6d02c773514e97cf47d69fcc086fa3ed.mp4";